import { Component, Input, Output, EventEmitter, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxOption } from '../primitives.types';

@Component({
  selector: 'kt-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  styleUrls: ['./checkbox-group.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CheckboxGroupComponent), multi: true }]
})
export class CheckboxGroupComponent implements ControlValueAccessor, OnChanges {
  @Input() options: CheckboxOption[] = [];
  @Input() label = '';
  @Input() orientation: 'vertical' | 'horizontal' = 'vertical';
  @Input() showSelectAll = false;
  @Input() disabled = false;
  @Input() required = false;
  @Input() errorMessage = '';
  @Input() hint = '';
  @Input() columns = 1;

  value: any[] = [];

  onChange = (_: any) => { };
  onTouched = () => { };

  ngOnChanges(changes: SimpleChanges) {
    if (changes['options'] && !this.value?.length) this.value = [];
  }

  get allChecked(): boolean {
    const enabled = this.options.filter(o => !o.disabled);
    return enabled.length > 0 && enabled.every(o => this.value.includes(o.value));
  }

  get someChecked(): boolean {
    const enabled = this.options.filter(o => !o.disabled);
    return enabled.some(o => this.value.includes(o.value)) && !this.allChecked;
  }

  isChecked(opt: CheckboxOption): boolean { return this.value.includes(opt.value); }

  onCheckChange(opt: CheckboxOption, checked: boolean) {
    const arr = [...this.value];
    if (checked) { if (!arr.includes(opt.value)) arr.push(opt.value); }
    else { const idx = arr.indexOf(opt.value); if (idx > -1) arr.splice(idx, 1); }
    this.value = arr;
    this.onChange(this.value);
    this.onTouched();
  }

  onSelectAllChange(checked: boolean) {
    this.value = checked ? this.options.filter(o => !o.disabled).map(o => o.value) : [];
    this.onChange(this.value);
    this.onTouched();
  }

  writeValue(value: any) { this.value = value ?? []; }
  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(isDisabled: boolean) { this.disabled = isDisabled; }
}
